import { render, staticRenderFns } from "./ClassFication.vue?vue&type=template&id=398d65b8&scoped=true&"
import script from "./ClassFication.vue?vue&type=script&lang=ts&"
export * from "./ClassFication.vue?vue&type=script&lang=ts&"
import style0 from "./ClassFication.vue?vue&type=style&index=0&id=398d65b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d65b8",
  null
  
)

export default component.exports